import { render } from "./Members.vue?vue&type=template&id=6f9ecaca&scoped=true&bindings={\"currentOrder\":\"data\",\"isLoading\":\"data\",\"error\":\"data\",\"getMembers\":\"options\",\"deleteSingleMember\":\"options\",\"handleError\":\"options\",\"sortedMember\":\"options\",\"allMembers\":\"options\",\"membersByFirstContact\":\"options\",\"membersByLastContact\":\"options\",\"membersByName\":\"options\"}"
import script from "./Members.vue?vue&type=script&lang=js"
export * from "./Members.vue?vue&type=script&lang=js"

import "./Members.vue?vue&type=style&index=0&id=6f9ecaca&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6f9ecaca"

export default script